import { Injectable } from '@angular/core';
import { ResourceEffect } from './resource.effect';

import { UserService } from '@app/core/services/user.service';
import { Action, Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { State } from '../reducers';
import {
  AddUser,
  CurrentUserLoad,
  CurrentUserLoadSuccess,
  LoadAllUsers,
  LoadAllUsersSuccess,
  LoadUserDetails,
  LoadUserDetailsSuccess,
  SaveUser,
  UpdateUser,
  UserActionTypes,
} from '@dwo/actions';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable()
export class UserEffects extends ResourceEffect {
  constructor(
    readonly actions$: Actions,
    readonly userService: UserService,
    readonly store: Store<State>,
  ) {
    super(actions$, userService, store);
  }

  loadCurrentUser$ = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType<CurrentUserLoad>(UserActionTypes.CurrentUserLoad),
        this.fetchResource('getCurrentUser', CurrentUserLoadSuccess),
      ),
  );

  loadAllUsers$ = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType<LoadAllUsers>(UserActionTypes.LoadAllUsers),
        this.fetchResource('loadAllUsers', LoadAllUsersSuccess),
      ),
  );

  addUser$ = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType<AddUser>(UserActionTypes.AddUser),
        this.fetchResource('addUser', LoadAllUsers, (action: AddUser) => [action.user]),
      ),
  );

  updateUser$ = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType<UpdateUser>(UserActionTypes.UpdateUser),
        this.fetchResource('updateUser', LoadAllUsersSuccess, (action: UpdateUser) => [action.user]),
      ),
  );

  loadUserDetails$ = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType<LoadUserDetails>(UserActionTypes.LoadUserDetails),
        this.fetchResource('loadUserDetails', LoadUserDetailsSuccess, (action: LoadUserDetails) => [action.username]),
      ),
  );

  saveUser$ = createEffect(
    (): Observable<Action> =>
      this.actions$.pipe(
        ofType<SaveUser>(UserActionTypes.SaveUser),
        switchMap((action: SaveUser) =>
          (this.userService.saveUser(action.user) as Observable<any>).pipe(
            switchMap((result) => [new LoadAllUsers(), new LoadUserDetails(action.user.username)]),
          ),
        ),
      ),
  );
}
